/** Window event fired by the source chart when user clicks Apply to All. */
export const APPLY_APPEARANCE_EVENT = "vnsc-apply-appearance-to-all";
/** Window event fired after fan-out completes (feedback + tests). */
export const APPLIED_APPEARANCE_EVENT = "vnsc-applied-appearance-to-all";
const SYMBOL_STYLE_KEYS = [
    "candleStyle",
    "upColor",
    "downColor",
    "borderUpColor",
    "borderDownColor",
    "wickUpColor",
    "wickDownColor",
    "showLastPriceLine",
    "lastPriceLineColor",
    "showPrevClosePriceLine",
    "prevClosePriceLineColor",
    "showHighLowPriceLines",
    "precision",
];
const SCALES_DISPLAY_KEYS = [
    "priceAxisPosition",
    "showSymbolLastValue",
    "showPrevCloseValue",
    "showIndicatorValues",
    "showCountdownToBarClose",
    "dateFormat",
    "timeFormat",
];
/** Extract the copyable appearance slice (pure). */
export function extractAppearancePayload(state) {
    const symbol = {};
    for (const k of SYMBOL_STYLE_KEYS) {
        symbol[k] = state.symbol[k];
    }
    const scales = {};
    for (const k of SCALES_DISPLAY_KEYS) {
        scales[k] = state.scales[k];
    }
    return {
        symbol,
        statusLine: { ...state.statusLine },
        scales,
        appearance: { ...state.appearance },
        theme: { ...state.theme },
    };
}
/**
 * Merge payload into a target state (pure). Blacklisted fields
 * (timezone, priceScaleMode/invertScale/showTimeScrollbar, panesLayout,
 * tradingEvents incl. dataAdapterName) are preserved from target.
 */
export function applyAppearancePayload(target, payload) {
    return {
        ...target,
        symbol: { ...target.symbol, ...payload.symbol },
        statusLine: { ...payload.statusLine },
        scales: { ...target.scales, ...payload.scales },
        appearance: { ...payload.appearance },
        theme: { ...payload.theme },
    };
}
